import { Skeleton, Stack } from '@mui/material';

interface EditEntitySplitScreenBodySkeletonProps {
  /** Number of field blocks to render. Defaults to two (e.g. primary +
   * contingent beneficiary tiers, or first/second-death recipients). */
  sectionCount?: number;
}

/**
 * Placeholder for the right-pane form while a newly selected target's data
 * loads. Mirrors the rough shape of the BDG/DP form bodies (an entity header
 * row followed by labeled field blocks) so swapping targets reads as the same
 * pane filling in, rather than a spinner replacing the whole pane.
 *
 * Intentionally omits the header — the stable split-screen header shell renders
 * the title/controls above this.
 */
export function EditEntitySplitScreenBodySkeleton({
  sectionCount = 2,
}: EditEntitySplitScreenBodySkeletonProps) {
  return (
    <Stack spacing={3} p={3} data-testid="EditEntitySplitScreenBodySkeleton">
      <Stack direction="row" spacing={2} alignItems="center">
        <Skeleton variant="circular" width={40} height={40} />
        <Stack spacing={0.5} flexGrow={1}>
          <Skeleton variant="text" width="45%" height={24} />
          <Skeleton variant="text" width="25%" height={16} />
        </Stack>
      </Stack>
      {Array.from({ length: sectionCount }).map((_, index) => (
        <Stack key={index} spacing={1.5}>
          <Skeleton variant="text" width="35%" height={20} />
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
        </Stack>
      ))}
    </Stack>
  );
}
